
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseInput',
  props: {
    labelClasses: {
      type: String,
    },
    inputClasses: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: String,
    },
    id: {
      type: String,
    },
    value: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['password', 'text', 'email', 'file', 'tel', 'number'].includes(value),
    },
  },
  methods: {
    callback: function (e) {
      this.$emit('input', e);
    },
    mapClasses: (type) => {
      let classes = '';
      switch (type) {
        case 'file':
          classes = 'hidden appearance-none';
          break;
      }
      return classes;
    },
    onBlur: function(e) {
      this.$refs.input.classList.remove('has-error');
      this.$emit('blur', e);
    },
  },
});
